import React, {useCallback, useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import PageTitle from '../components/pagetitle/PageTitle';
import {Link, useParams} from 'react-router-dom';
import img1 from '../assets/images/item-details.jpg';
import avt1 from '../assets/images/author/author-detail-3.png';
import data from '../assets/fake-data/data-hotpick';
import icon1 from '../assets/images/icon/rain1.svg';
import icon2 from '../assets/images/icon/rain2.svg';
import icon3 from '../assets/images/icon/ethe.svg';
import CardModal from '../components/layouts/CardModal';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import avtd1 from '../assets/images/author/author-detail-1.png';
import avtd2 from '../assets/images/author/author-detail-2.png';
import avtd3 from '../assets/images/author/authour-bid-1.png';
import avtd4 from '../assets/images/author/authour-bid-2.png';
import avtd5 from '../assets/images/author/authour-bid-3.png';
import avtd6 from '../assets/images/author/author-history-1.jpg';
import avtd7 from '../assets/images/author/author-history-2.jpg';
import SUIIcon from '../assets/images/svg/sui-icon.svg';
import {useBlockchainContext} from '@/contexts/BlockchainContext';
import {useCollectionQuery, useNFTQuery, useUpdateNFTMutation} from '@/hooks';
import {useNFTProtocolContext} from '@/contexts/NFTProtocolContext';
import {getAllObjectOfAddress, getObjectById} from '@/utils/SuiObject';
import {Coin} from '@mysten/sui.js';
import {shortAddress} from '@/utils/utils';

ItemDetails01.propTypes = {};

function ItemDetails01(props) {
  const [modalShow, setModalShow] = useState(false);
  const params = useParams();

  const {nftId} = params;
  const [NFTInfo, setNFTInfo] = useState({});
  const [NFTCert, setNFTCert] = useState();
  const {data: dataNft, refetch} = useNFTQuery({nftId});
  const {data: dataCollection} = useCollectionQuery({collectionId: dataNft?.collectionId});
  const {mutateAsync: updateNft} = useUpdateNFTMutation();
  const collectionInfo = dataCollection?.[0]?.dataObject?.ret?.collection;
  const launchpadYamlInfo = dataCollection?.[0]?.dataObject?.data?.launchpadYaml;
  const {saleOffNft, saleOnNft, buyNftCert, claimNftCert} = useNFTProtocolContext();
  const {addressWallet} = useBlockchainContext();
  const [tabDetails, setTabDetails] = useState([
    {
      id: 1,
      heading: 'Current Owner',
      avt: avtd1,
      name: '',
    },
    {
      id: 2,
      heading: 'Creator',
      avt: avtd2,
      name: '',
    },
  ]);
  const [tabBid] = useState([
    {
      id: 1,
      avt: avtd3,
      price: '1.35 ETH',
      name: 'carlisle',
      time: '3/26/2022, 7:28 AM',
    },
    {
      id: 2,
      avt: avtd4,
      price: '1.35 ETH',
      name: 'carlisle',
      time: '3/26/2022, 7:28 AM',
    },
    {
      id: 3,
      avt: avtd5,
      price: '1.35 ETH',
      name: 'carlisle',
      time: '3/26/2022, 7:28 AM',
    },
    {
      id: 4,
      avt: avtd3,
      price: '1.35 ETH',
      name: 'carlisle',
      time: '3/26/2022, 7:28 AM',
    },
    {
      id: 5,
      avt: avtd4,
      price: '1.35 ETH',
      name: 'carlisle',
      time: '3/26/2022, 7:28 AM',
    },
    {
      id: 6,
      avt: avtd5,
      price: '1.35 ETH',
      name: 'carlisle',
      time: '3/26/2022, 7:28 AM',
    },
  ]);

  const [tabHistory] = useState([
    {
      id: 1,
      name: 'Mason Woodward',
      avt: avtd6,
    },
    {
      id: 2,
      name: 'Violet Pascall ',
      avt: avtd7,
    },
    {
      id: 3,
      name: 'Camilla Hudson ',
      avt: avtd6,
    },
    {
      id: 4,
      name: 'Derick Reed ',
      avt: avtd7,
    },
    {
      id: 5,
      name: 'Mason Woodward',
      avt: avtd6,
    },
  ]);

  useEffect(() => {
    getNftInfo();
  }, [dataNft]);

  useEffect(() => {
    getNftCert();
  }, [NFTInfo]);

  const getNftInfo = async () => {
    if (dataNft) {
      const res = await getObjectById(dataNft?.launchpadId);
      console.log('res', res);
      setNFTInfo(res?.data);
    }
  };

  const listingNft = async () => {
    if (NFTInfo?.fields?.live) {
      await saleOffNft(dataNft?.launchpadId, collectionInfo?.witnessTypeArg);
    } else {
      await saleOnNft(dataNft?.launchpadId, collectionInfo?.witnessTypeArg);
    }
    getNftInfo();
  };

  const getNftCert = async () => {
    if (!dataNft) return;
    const nftCertObject = await getObjectById(dataNft?.nftCertificate);
    console.log(nftCertObject, 'nftCertObject');
    if (nftCertObject && nftCertObject?.owner?.AddressOwner === addressWallet) {
      setNFTCert(nftCertObject);
    }
  };

  const buyNft = async () => {
    console.log(dataNft?.launchpadId);
    if (NFTInfo?.fields?.live) {
      const res = await buyNftCert(dataNft?.launchpadId, 0, 100, collectionInfo?.witnessTypeArg);
      console.log(res, 'buynft');
      if (res) {
        await updateNft({
          id: dataNft.id,
          data: {nftCertificate: res?.effects.created?.[1]?.reference?.objectId, nftOwner: addressWallet},
        });
        refetch();
      }
    } else {
      await claimNftCert(dataNft?.launchpadId, nftId, dataNft?.nftCertificate, collectionInfo?.witnessTypeArg);
    }
    getNftInfo();
  };

  const claimNft = async () => {
    const res = await claimNftCert(
      dataNft?.launchpadId,
      NFTCert?.data?.fields?.nft_id,
      dataNft?.nftCertificate,
      collectionInfo?.witnessTypeArg
    );
    if (res) {
      await updateNft({
        id: dataNft.id,
        data: {nftCertificate: ''},
      });
      refetch();
    }
    getNftInfo();
  };

  return (
    <div>
      <PageTitle sub="Explore" title="Item Details" />

      <section className="tf-item-detail">
        <div className="tf-container">
          <div className="row">
            <div className="col-md-12">
              <div className="tf-item-detail-inner">
                <div className="image">
                  <img src={dataNft?.url} alt="Binasea" />
                </div>
                <div className="content">
                  <div className="content-top">
                    <div className="author">
                      <img src={avt1} alt="Binasea" />
                      <h6 className="title">Trending Arts</h6>
                    </div>
                    {/* <div className="wishlish">
                      <div className="number-wishlish">
                        <i className="fas fa-heart"></i>
                      </div>
                      <div className="option btn-option">
                        <i className="fas fa-ellipsis-h"></i>
                        <div className="option_popup">
                          <Link to="#">Delete</Link>
                          <Link to="#">Edit</Link>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <h2 className="title-detail">{dataNft?.name}</h2>
                  <p className="except">{dataNft?.description}</p>

                  <Tabs className="tf-tab">
                    <TabList className="menu-tab ">
                      <Tab className="tab-title active">
                        <Link to="#">Details</Link>
                      </Tab>
                      {/* <Tab className="tab-title ">
                        <Link to="#">Bids</Link>
                      </Tab> */}
                      <Tab className="tab-title ">
                        <Link to="#">History</Link>
                      </Tab>
                    </TabList>

                    <TabPanel key="detail">
                      <div className="tab-details">
                        <div className="top">
                          <div key={'current'} className="author">
                            <div className="heading">Current Owner</div>
                            <div className="infor">
                              <img src={avt1} alt="Binasea" />
                              <h6 className="name">{shortAddress(dataNft?.nftOwner)}</h6>
                            </div>
                          </div>
                          <div key={'current'} className="author">
                            <div className="heading">Creator</div>
                            <div className="infor">
                              <img src={avt1} alt="Binasea" />
                              <h6 className="name">{shortAddress(dataCollection?.[0]?.authority)}</h6>
                            </div>
                          </div>
                        </div>
                        {dataNft?.attributeKeys?.length > 0 && (
                          <>
                            <div className="title-propepties">Properties</div>
                            <ul className="properties">
                              {dataNft?.attributeKeys?.map((el, index) => (
                                <li>{dataNft?.attributeValues[index]}</li>
                              ))}
                            </ul>
                          </>
                        )}
                      </div>
                    </TabPanel>
                    {/* <TabPanel>
                      <ul className="tab-bid">
                        {tabBid.map((idx) => (
                          <li key={idx.id}>
                            <div className="box-bid">
                              <div className="image-bid">
                                <img src={idx.avt} alt="Binasea" />
                              </div>
                              <div className="infor">
                                <div className="history">
                                  <span className="price">{idx.price}</span> by <span className="name">{idx.name}</span>
                                </div>
                                <div className="time">{idx.time}</div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </TabPanel> */}
                    <TabPanel key="history">
                      <ul className="tab-history">
                        {tabHistory.map((idx) => (
                          <li key={idx.id}>
                            <div className="box-history">
                              <div className="infor">
                                <div className="img">
                                  <img src={idx.avt} alt="Binasea" />
                                </div>
                                <div className="content">
                                  <h6 className="name">
                                    {idx.name} <span>place a bid</span>
                                  </h6>
                                  <p className="time">8 hours ago</p>
                                </div>
                              </div>
                              <div className="price">
                                <p>4.89 ET</p>
                                <span>= $12.245</span>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </TabPanel>
                  </Tabs>

                  <div className="content-bottom">
                    <div className="heading">
                      <h6>Current price</h6>
                      <div className="price">
                        <div className="icon">
                          <img src={SUIIcon} alt="sui" />
                        </div>
                        <span>{launchpadYamlInfo?.prices?.[dataNft?.saleIndex]} SUI</span>
                      </div>
                    </div>
                    <div className="button">
                      {dataNft?.nftOwner === addressWallet ? (
                        !NFTCert ? (
                          collectionInfo?.authority === addressWallet && (
                            <button
                              onClick={listingNft}
                              className="tf-button"
                              data-toggle="modal"
                              data-target="#popup_bid"
                            >
                              {NFTInfo?.fields?.live ? 'Delisting NFT' : 'Listing NFT'}
                            </button>
                          )
                        ) : (
                          <button onClick={claimNft} className="tf-button" data-toggle="modal" data-target="#popup_bid">
                            {'Claim'}
                          </button>
                        )
                      ) : (
                        <button onClick={buyNft} className="tf-button" data-toggle="modal" data-target="#popup_bid">
                          {NFTInfo?.fields?.live && 'Buy'}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tf-explore-more">
        <div className="tf-container">
          <div className="row">
            <div className="col-md-12">
              <div className="tf-heading">
                <h4 className="heading">Explore More</h4>
              </div>
            </div>

            {data.slice(0, 4).map((idx) => (
              <div key={idx.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
                <div className="sc-product style2">
                  <div className="top">
                    <Link to="/item-details-v1" className="tag">
                      {idx.title}
                    </Link>
                    <div className="wish-list">
                      <Link to="#" className="heart-icon"></Link>
                    </div>
                  </div>
                  <div className="bottom">
                    <div className="details-product">
                      <div className="author">
                        <div className="avatar">
                          <img src={idx.avt} alt="images" />
                        </div>
                        <div className="content">
                          <div className="position">Creator</div>
                          <div className="name">
                            {' '}
                            <Link to="#">{shortAddress(dataCollection?.authority)}</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="features">
                    <div className="product-media">
                      <img src={idx.img} alt="images" />
                    </div>
                    <div className="rain-drop1">
                      <img src={icon1} alt="images" />
                    </div>
                    <div className="rain-drop2">
                      <img src={icon2} alt="images" />
                    </div>
                  </div>
                  <div className="bottom-style2">
                    <div className="price">
                      <div className="icon">
                        <img src={icon3} alt="images" />
                      </div>
                      <div className="content">
                        <div className="name">ETH</div>
                        <div className="cash">{idx.price}</div>
                      </div>
                    </div>
                    <div className="product-button">
                      <Link
                        to="#"
                        onClick={() => setModalShow(true)}
                        data-toggle="modal"
                        data-target="#popup_bid"
                        className="tf-button"
                      >
                        {' '}
                        Purchase
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <CardModal show={modalShow} onHide={() => setModalShow(false)} />
      </section>
    </div>
  );
}

export default ItemDetails01;
